import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JsonComparisonComponent } from './json-comparison.component';


@NgModule({
  declarations: [
    JsonComparisonComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [JsonComparisonComponent],
})
export class JsonComparisonModule {
}
